import { FAQProps, FAQEditorProps, FAQItem } from './FAQ.types';

/**
 * 원본 props를 FAQ 컴포넌트에 맞게 변환
 * 
 * @param originalProps 원본 props
 * @returns 변환된 FAQ 컴포넌트 props
 */
export function adaptFAQProps(originalProps: any): FAQProps {
  // 기본값 설정
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 제목 값 추출 (여러 경로에서 가져오기)
  const title = originalProps?.title || 
                originalContent?.title || 
                originalComponentProps?.title ||
                "자주하는질문";
  
  // FAQ 항목 추출 (여러 경로에서 가져오기)
  let faqItems: FAQItem[] = [];
  
  if (Array.isArray(originalProps?.faqItems)) {
    faqItems = originalProps.faqItems;
  } else if (Array.isArray(originalContent?.faqItems)) {
    faqItems = originalContent.faqItems;
  } else if (Array.isArray(originalComponentProps?.faqItems)) {
    faqItems = originalComponentProps.faqItems;
  }
  
  // 스타일 병합
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 제목 스타일 병합
  const titleStyle = {
    ...(originalProps?.titleStyle || {}),
    ...(originalProps?.style?.titleStyle || {}),
    ...(originalComponentProps?.titleStyle || {})
  };
  
  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';

  // 변환된 props 반환
  const adaptedProps: FAQProps = {
    id: originalProps?.id || '',
    title,
    faqItems,
    style,
    titleStyle,
    className,
    content: { 
      ...originalContent,
      title,
      faqItems
    },
    componentProps: {
      ...originalComponentProps,
      title,
      faqItems
    },
    data: originalProps?.data || {}
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['id', 'title', 'faqItems', 'style', 'titleStyle', 'className', 'content', 'componentProps', 'data'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 원본 props를 FAQ 에디터 컴포넌트에 맞게 변환
 * 
 * @param originalProps 원본 props
 * @returns 변환된 FAQ 에디터 컴포넌트 props
 */
export function adaptFAQEditorProps(originalProps: any): FAQEditorProps {
  // 기본 props 변환
  const adaptedProps = adaptFAQProps(originalProps);
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 